module.exports={"error-screen":{"not-found":"Screen cannot be found!"}};